// src/components/Dashboard/charts/OrdersRevenueArea.js
// Área apilada que muestra la evolución de ventas diarias (US$).
// Se asume que el array "data" contiene objetos { dateLabel: '2025-07-12', revenue: 123 }.

import React from 'react';
import PropTypes from 'prop-types';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Box, Typography } from '@mui/material';

export default function OrdersRevenueArea({ data = [] }) {
  return (
    <Box sx={{ width: '100%', height: 300 }}>
      <Typography variant="subtitle1" gutterBottom>
        Evolución diaria de ventas
      </Typography>
      {data.length === 0 ? (
        <Typography variant="body2">Sin datos disponibles.</Typography>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorRev" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#4e73df" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#4e73df" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="dateLabel" tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={(v) => `US$ ${v / 1000}k`} />
            <Tooltip formatter={(v) => `US$ ${v.toLocaleString()}`} />
            <Area type="monotone" dataKey="revenue" stroke="#4e73df" fillOpacity={1} fill="url(#colorRev)" />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
}

OrdersRevenueArea.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      dateLabel: PropTypes.string.isRequired,
      revenue: PropTypes.number.isRequired,
    })
  ),
};
